/**
 * Constants that are used in the Cadenza API. (Workbooks only, no classic stuff)
 *
 * @see Published \- The constants are also used in {@link https://github.com/DisyInformationssysteme/cadenza.js|Cadenza JS}.
 */

export const PARAMETER_ACTION = 'action'; // CadenzaApiAction

/** Map views: The geometry type for creating a new geometry */
export const PARAMETER_GEOMETRY_TYPE = 'geometryType'; // GeoJSONGeometryType
/** Map views: Whether to enable batch mode for geometry editor */
export const PARAMETER_BATCH_MODE_ENABLED = 'batchModeEnabled'; //Boolean
/** Map views: The value of the location finder */
export const PARAMETER_LOCATION_FINDER = 'locationFinder'; // string
/** Map views: The map extent */
export const PARAMETER_MAP_EXTENT = 'mapExtent'; // WorldBoxDto
/** Map views: The minimum scale the user should work on. A warning is shown when exceeded. */
export const PARAMETER_MIN_SCALE = 'minScale'; // number
/** Operation mode ("simplified" or "normal") */
export const PARAMETER_OPERATION_MODE = 'operationMode'; // OperationMode
/**
 * Map views: Whether the use the map's SRS for the map extent or for geometries.
 * By default, the GeoJSON default SRS is used (WGS84).
 */
export const PARAMETER_USE_MAP_SRS = 'useMapSrs'; // boolean
/** Select objects: Layers where objects can be selected */
export const PARAMETER_LAYERS = 'layers';
